// extracted by mini-css-extract-plugin
export var fadeIn = "_i0-1";
export var modalContent = "_i0-3";
export var overlay = "_i0-0";
export var popoverContent = "_i0-2";
export var results = "_i0-5";
export var searchInputWrapper = "_i0-4";